import { IApplicationState } from 'app/types/types';
import { getBoard } from 'app/store/model/selectors/getBoardById';
import { connect } from 'react-redux';
import { BoardDescription } from '../../components/BoardDescription/BoardDescription';
import { IBoardDescriptionEvents, IBoardDescriptionFields } from '../../components/BoardDescription/types';
import { blockMarkdown } from 'app/helper/markdownHelper';
import { onSave } from './events/onSave';
import { onCtrlEnter } from './events/onCtrlEnter';
import { onCancel } from './events/onCancel';
import { onEsc } from './events/onEsc';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';
import { getPanelReadonly } from '../../../../selectors/getPanelReadonly';
import { IBoardDescriptionHOCProps } from './types';

const mapStateToProps = (
    state: IApplicationState,
    ownProps: IBoardDescriptionHOCProps
): IBoardDescriptionFields => {
    const { boardId, nameHeight } = ownProps;
    const board = getBoard(state, boardId);
    let description = board ? board.description : '';
    let descriptionMarkdown = description;
    if (description) {
        descriptionMarkdown = blockMarkdown(description);
    }

    return {
        description,
        descriptionMarkdown,
        isDisabled: getPanelReadonly(state, boardId),
        nameHeight,
    }
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IBoardDescriptionHOCProps
): IBoardDescriptionEvents => {
    const { boardId, setDescriptionEditing } = ownProps;
    return {
        onSave: (description: string) => dispatch(onSave(boardId, description)),
        onCancel: () => dispatch(onCancel()),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
        onCtrlEnter: (description: string) => dispatch(onCtrlEnter(boardId, description)),
        onEsc: () => dispatch(onEsc()),
        setDescriptionEditing,
    }
};

export const BoardDescriptionHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(BoardDescription);

BoardDescriptionHOC.displayName = 'BoardDescriptionHOC';
